import { useStoreActivate } from '@/store/activate';
const store = useStoreActivate();


// アクティベート
export function storeSetActivateInviteCode(invite_id) {
    store.invite_id = invite_id;
}
export function storeSetActivateInviteStatus(status) {
    store.status = status;
}
export function storeSetActivateInviteError(error) {
    store.invite_error = error;
}
export function storeResetActivate() {
    store.invite_id = null
    store.status = {}
}
export function storeGetActivateInviteCode() {
    return store.invite_id
}
export function storeGetActivateInviteStatus() {
    return store.status
}
export function storeGetActivateInviteError() {
    return store.invite_error
}

// （外部認証用）利用規約同意状態
export function storeSetPortalTerms(is_portal_terms = false) {
    store.is_portal_terms = is_portal_terms;
}
export function storeIsPortalTerms() {
    return store.is_portal_terms
}

export default {
    storeSetActivateInviteCode,
    storeSetActivateInviteStatus,
    storeSetActivateInviteError,
    storeResetActivate,
    storeGetActivateInviteCode,
    storeGetActivateInviteStatus,
    storeGetActivateInviteError,

    storeSetPortalTerms,
    storeIsPortalTerms,
}